module.exports = __webpack_public_path__ + "img/icon2.a0e564c8.png";